// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__QpgwF","validationTips":"StatementDescriptor_validationTips__1kbdW"};